export default __webpack_public_path__ + "static/media/Lock-login.8966a43d.svg";